<template>
  <b-row>
    <b-col cols="12" class="mb-32 mt-16">
      <b-row align-h="between" class="mt-n32">
        <b-col class="hp-flex-none w-auto mt-32">
          <breadcrumb activeTitle="Plantillas" />
        </b-col>
        <b-col class="hp-flex-none w-auto mt-24">
          <b-row>
            <b-col class="hp-flex-none w-auto pr-0">
              <b-button
                v-if="
                  currentUser &&
                  checkIfHaveRole(currentUser.rol, [
                    ROLES.coordinator,
                    ROLES.superadmin,
                  ])
                "
                @click="$refs.editChecklist.openModal()"
                variant="primary"
                class="btn-ghost"
                >Agregar Plantilla</b-button
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12" class="mb-32">
      <h2 class="mb-0">Plantillas</h2>
      <h5 class="mb-0 text-black-80 hp-text-color-dark-30">
        Listado de plantillas del punto de instalación
      </h5>
    </b-col>

    <div class="d-flex align-items-center justify-content-center mx-auto mt-3">
      <b-spinner
        v-if="loading && checklistDOCXProgress.id"
        class="mx-2"
        variant="warning"
      ></b-spinner>
      <span
        class="text-warning mx-1 text-center"
        v-if="
          checklistDOCXProgress.id && !isNaN(checklistDOCXProgress.progress)
        "
        >{{ checklistDOCXProgress.progress }}%</span
      >
    </div>
    <b-col cols="12">
      <datatable
        :items="computedPlaceChecklists"
        :fields="camposTabla"
        :filter-input-cols="5"
      >
        <template #filters>
          <b-col cols="12" xl="4" md="4" sm="12">
            <b-form-select
              id="SectionType"
              v-model="filters.section"
              class="my-3"
              :options="wrappedSections"
              value-field="id"
              text-field="name"
              @change="
                getPlaceChecklists({
                  place_id: $route.params.id,
                  section: filters.section || undefined,
                })
              "
            />
          </b-col>
        </template>
        <template #checklist_type_show="{ item }">
          <span>
            {{
              item.checklist.checklist_type
                ? item.checklist.checklist_type.name
                : "Sin tipo"
            }}
          </span>
        </template>
        <template #status="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-approved-answers`"
              variant="primary"
            >
              {{ item.checklist.status.approved_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-approved-answers`"
              >Porcentaje de respuestas aprobadas</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-pending-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.pending_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-pending-answers`"
              >Porcentaje de respuestas pendientes de aprobar</b-tooltip
            >
          </div>
        </template>
        <template #questions="{ item }">
          <div class="d-flex justify-content-start">
            <b-progress
              :value="item.checklist.status_completed"
              :max="100"
              class="w-75 mr-2"
              variant="warning"
            >
              <b-progress-bar :value="item.checklist.status_completed">
              </b-progress-bar>
            </b-progress>
            <small> {{ item.checklist.status_completed }}% </small>
          </div>
        </template>
        <template #rejected="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              class="pointer"
              :id="`${item.checklist.id}-rejected-answers`"
              @click="goToRejected(item)"
              variant="danger"
            >
              {{ item.checklist.status.rejected_total }}
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-rejected-answers`"
              >Cantidad de respuestas rechazadas</b-tooltip
            >
          </div>
        </template>
        <template #pending_replacement="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-pending-replacement-answers-percent`"
              variant="primary"
            >
              {{ item.checklist.status.pending_replacement_percent }}%
            </b-badge>
            <b-tooltip
              :target="`${item.checklist.id}-pending-replacement-answers-percent`"
              >Porcentaje de respuestas pendientes de sustitución</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-pending-replacement-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.pending_replacement }}
            </b-badge>
            <b-tooltip
              :target="`${item.checklist.id}-pending-replacement-answers`"
              >Cantidad de respuestas pendientes de sustitución</b-tooltip
            >
          </div>
        </template>
        <template #replaced="{ item }">
          <div class="d-flex align-items-center justify-content-center">
            <b-badge
              :id="`${item.checklist.id}-replaced-answers-percent`"
              variant="primary"
            >
              {{ item.checklist.status.replaced_percent }}%
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-replaced-answers-percent`"
              >Porcentaje de respuestas sustituidas</b-tooltip
            >
            <b-badge
              :id="`${item.checklist.id}-replaced-answers`"
              variant="info"
              class="mx-2"
            >
              {{ item.checklist.status.replaced }}
            </b-badge>
            <b-tooltip :target="`${item.checklist.id}-replaced-answers`"
              >Cantidad de respuestas sustituidas</b-tooltip
            >
          </div>
        </template>
        <template #copec="{ item }">
          <div
            class="d-flex align-items-center justify-content-center"
            v-if="copecMeta(item) && copecMeta(item).show"
          >
            <b-badge
              :id="`${item.id}-copec`"
              :variant="copecMeta(item).variant"
              class="pointer"
              @click="abrirHistorialCopec(item)"
            >
              {{ copecMeta(item).label }}
            </b-badge>
            <b-tooltip :target="`${item.id}-copec`"
              >Estado del envío de números de serie a la APP Copec. Haz clic para ver el
              historial de intentos.</b-tooltip
            >
          </div>
          <span v-else class="text-black-40">—</span>
        </template>
        <template #actions="{ item }">
          <div class="d-flex justify-content-center">
            <b-button
              :disabled="!item.checklist.question_count"
              :id="`${item.checklist.id}-show-checklist`"
              size="sm"
              v-b-tooltip.hover
              :title="
                item.checklist.question_count
                  ? 'Responder plantilla'
                  : 'Esta plantilla no tiene preguntas'
              "
              variant="primary"
              @click="goToQuestionsChecklist(item)"
              class="btn-ghost mx-2"
            >
              <i class="iconly-Light-Show"></i>
            </b-button>

            <b-dropdown
              size="sm"
              class="btn-ghost mx-1"
              variant="outline-warning"
              v-if="
                currentUser &&
                checkIfHaveRole(currentUser.rol, [
                  ROLES.coordinator,
                  ROLES.inspector,
                  ROLES.superadmin,
                ])
              "
            >
              <template #button-content>
                <i class="iconly-Curved-MoreSquare"></i>
              </template>
              <b-dropdown-item
                v-if="hasDocumentTypeOptions(item)"
                @click="openDownloadDocxModal(item)"
              >
                Descargar informe
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  currentUser &&
                  checkIfHaveRole(currentUser.rol, [
                    ROLES.coordinator,
                    ROLES.inspector,
                    ROLES.superadmin,
                  ])
                "
                @click="
                  $refs.uploadOrGenerateFileProyectPlataform.openModal(
                    item.id,
                    item.checklist.id
                  )
                "
              >
                Subir PDF a Plataforma Proyectos
              </b-dropdown-item>
              <b-dropdown-item
                v-if="aplicaCopec(item)"
                @click="abrirHistorialCopec(item)"
              >
                Ver historial de envíos a la APP Copec
              </b-dropdown-item>
              <b-dropdown-item
                v-if="aplicaCopec(item) && puedeEnviarCopec(item)"
                @click="enviarACopec(item)"
              >
                {{
                  copecEstado(item) === "error"
                    ? "Reintentar envío a la APP Copec"
                    : "Enviar series a la APP Copec"
                }}
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  aplicaCopec(item) &&
                  copecEstado(item) === 'enviado' &&
                  currentUser &&
                  checkIfHaveRole(currentUser.rol, [
                    ROLES.coordinator,
                    ROLES.superadmin,
                  ])
                "
                @click="enviarACopec(item, true)"
              >
                Reenviar a la APP Copec de todos modos
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  currentUser &&
                  checkIfHaveRole(currentUser.rol, [
                    ROLES.coordinator,
                    ROLES.superadmin,
                  ])
                "
                @click="deleteAnswersPlaceChecklist(item)"
              >
                Limpiar respuestas de plantilla
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  currentUser &&
                  checkIfHaveRole(currentUser.rol, [
                    ROLES.coordinator,
                    ROLES.superadmin,
                  ])
                "
                @click="deletePlaceChecklist(item)"
              >
                Eliminar plantilla
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </datatable>
    </b-col>

    <update-or-create-place-checklist
      ref="editChecklist"
      @success="
        getPlaceChecklists({
          place_id: $route.params.id,
          section: filters.section || undefined,
        })
      "
    ></update-or-create-place-checklist>
    <upload-or-autogenerate-file-to-proyect-plataform
      ref="uploadOrGenerateFileProyectPlataform"
      @pdfUploaded="
        getPlaceChecklists({
          place_id: $route.params.id,
          section: filters.section || undefined,
        })
      "
    >
    </upload-or-autogenerate-file-to-proyect-plataform>
    <modal-questions-answers-rejected
      ref="modalQuestionsAnswerRejected"
      :answersRejected="imagesRejectedQuestion"
    >
    </modal-questions-answers-rejected>
    <modal-copec-sync-history
      ref="modalCopecSync"
      @enviar="enviarACopecDesdeModal"
    ></modal-copec-sync-history>

    <b-modal id="modal-download-docx" centered hide-footer title="Descargar informe">
      <b-form-group
        label="Selecciona el tipo de documento"
        label-for="download-docx-type"
      >
        <b-form-select
          id="download-docx-type"
          class="download-docx-select"
          v-model="selectedDownloadDocumentType"
        >
          <template #first>
            <b-form-select-option :value="null" disabled
              >Selecciona tipo de documento</b-form-select-option
            >
          </template>
          <b-form-select-option
            v-for="option in availableDocumentTypes"
            :key="option.value"
            :value="option.value"
          >
            {{ option.text }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Correo destinatario" label-for="recipient-email">
        <b-form-input
          id="recipient-email"
          v-model="recipientEmail"
          type="email"
          placeholder="correo@dominio.com"
          :state="recipientEmail ? isRecipientEmailValid : null"
          @input="errorMessage = ''"
        />
        <b-form-invalid-feedback v-if="recipientEmail && !isRecipientEmailValid">
          Ingresa un correo electrónico válido.
        </b-form-invalid-feedback>
      </b-form-group>

      <p v-if="errorMessage" class="text-danger mb-2">{{ errorMessage }}</p>

      <div class="d-flex justify-content-end">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="$bvModal.hide('modal-download-docx')"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          :disabled="
            !selectedDownloadDocumentType ||
            !currentChecklistToDownload ||
            isLoading
          "
          @click="downloadSelectedDocxType"
        >
          Descargar
        </b-button>
        <b-button
          variant="success"
          class="ml-2"
          :disabled="
            !selectedDownloadDocumentType ||
            !currentChecklistToDownload ||
            !isRecipientEmailValid ||
            isLoading
          "
          @click="sendDocxByEmail"
        >
          Enviar por correo
        </b-button>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import Breadcrumb from "@/layouts/components/content/breadcrumb/Breadcrumb.vue";
import { mapActions, mapGetters } from "vuex";
import UpdateOrCreatePlaceChecklist from "./updateOrCreatePlaceChecklist.vue";
import Datatable from "@/view/components/common/datatable/Datatable.vue";
import { verifyRole } from "@/mixins/role";
import UploadOrAutogenerateFileToProyectPlataform from "./uploadOrAutogenerateFileToProyectPlataform.vue";
import { ROLES } from "@/constants/roles";
import ModalQuestionsAnswersRejected from "@/view/pages/app/questions/components/ModalQuestionsAnswersRejected.vue";
import {
  verifyIfChecklistIdTechnicalReport,
  verifyIfChecklistFieldReport,
  getTypeChecklistFromChecklist,
} from "@/constants/checklist";
import ModalCopecSyncHistory from "./ModalCopecSyncHistory.vue";
import {
  COPEC_ESTADOS_ENVIABLES,
  copecMetaFromStatus,
} from "@/constants/integrations";

export default {
  mixins: [verifyRole],
  components: {
    Breadcrumb,
    UpdateOrCreatePlaceChecklist,
    UploadOrAutogenerateFileToProyectPlataform,
    Datatable,
    ModalQuestionsAnswersRejected,
    ModalCopecSyncHistory,
  },
  async mounted() {
    if (this.userAuth?.rol == ROLES.superadmin) {
      await this.getSections();
      this.filters.section = this.sections[0].id;
    } else {
      await this.getSectionsUser({
        place_id: this.$route.params.id,
      });
      this.filters.section = this.sectionsUser[0].id;
    }
    await this.getPlaceChecklists({
      place_id: this.$route.params.id,
      section: this.filters.section,
    });
    await this.recargarEstadosCopec();
  },
  data() {
    return {
      loading: false,
      fields: [
        { key: "actions", label: "Acciones", class: "px-2" },
        {
          key: "checklist.name",
          label: "Nombre",
          sortable: true,
          class: "text-center px-1",
        },
        {
          key: "questions",
          label: "Preguntas",
          sortable: false,
          class: "px-3",
        },
        {
          key: "status",
          label: "Respuestas",
          sortable: false,
          class: "text-center px-2",
        },
        {
          key: "rejected",
          label: "Rechazadas",
          sortable: false,
          class: "text-center px-1",
        },
        {
          key: "pending_replacement",
          label: "Pendientes de sustitución",
          sortable: false,
          class: "text-center pl-2",
        },
        {
          key: "replaced",
          label: "Sustituidas",
          sortable: false,
          class: "text-center px-1",
        },
      ],
      filters: {
        section: null,
      },
      imagesRejectedQuestion: [],
      currentChecklistToDownload: null,
      availableDocumentTypes: [],
      selectedDownloadDocumentType: null,
      recipientEmail: "",
      isLoading: false,
      errorMessage: "",
    };
  },
  methods: {
    getTypeChecklistFromChecklist,
    ...mapActions({
      getPlaceChecklists: "place/getPlaceChecklists",
      sendDeletePlaceChecklist: "place/deletePlaceChecklist",
      getDocxFromPlaceChecklist: "checklist/getDocxFromPlaceChecklist",
      getSections: "project/getSections",
      getSectionsUser: "project/getSectionsUser",
      getQuestionsRejected: "question/getQuestionsRejected",
      sendDeleteAnswersPlaceChecklist: "place/deleteAnswersPlaceChecklist",
      getQuestions: "question/getQuestions",
      getCopecStatusByPlace: "integrations/getCopecStatusByPlace",
      sendCopecSync: "integrations/sendCopecSync",
    }),
    verifyIfChecklistIdTechnicalReport,
    verifyIfChecklistFieldReport,
    async recargarEstadosCopec() {
      await this.getCopecStatusByPlace({ place_id: this.$route.params.id });
    },
    aplicaCopec(item) {
      return (
        this.copecConfiguredChecklistId &&
        item.checklist &&
        item.checklist.id === this.copecConfiguredChecklistId
      );
    },
    copecEstado(item) {
      const estado = this.copecStatuses[String(item.id)];
      return estado ? estado.status : null;
    },
    copecMeta(item) {
      if (!this.aplicaCopec(item)) return null;
      const estado = this.copecEstado(item);
      return estado ? copecMetaFromStatus(estado) : null;
    },
    puedeEnviarCopec(item) {
      return COPEC_ESTADOS_ENVIABLES.includes(this.copecEstado(item));
    },
    abrirHistorialCopec(item) {
      if (!this.aplicaCopec(item)) return;
      this.$refs.modalCopecSync.openModal(item.id);
    },
    async enviarACopecDesdeModal(placeChecklistId) {
      const item = this.computedPlaceChecklists.find(
        (e) => e.id === placeChecklistId
      );
      if (item) await this.enviarACopec(item, this.copecEstado(item) === "enviado");
    },
    async enviarACopec(item, forzar = false) {
      const estado = this.copecStatuses[String(item.id)] || {};
      if (forzar) {
        const confirmado = await this.$bvModal.msgBoxConfirm(
          `El último envío correcto fue el ${
            estado.last_sent_at
              ? new Date(estado.last_sent_at).toLocaleString("es-CL")
              : "—"
          }. ¿Quieres enviar los mismos datos otra vez?`,
          {
            title: "Estos datos ya se enviaron correctamente",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "Reenviar de todos modos",
            cancelTitle: "Cancelar",
            cancelVariant: "outline-info-3",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        );
        if (!confirmado) return;
      }

      const respuesta = await this.sendCopecSync({
        place_checklist_id: item.id,
        force: forzar,
      });
      await this.recargarEstadosCopec();
      if (this.$refs.modalCopecSync) await this.$refs.modalCopecSync.recargar();

      const datos = respuesta.data || {};
      if (respuesta.status === 200) {
        return this.$bvToast.toast(
          `Se enviaron ${datos.sync_jobs} número(s) de serie al código ${datos.location_code}`,
          {
            title: "Números de serie enviados a la APP Copec",
            variant: "primary",
            solid: false,
          }
        );
      }
      if (respuesta.status === 422) {
        return this.$bvToast.toast(
          `No se pudo enviar: ${(datos.errors || ["faltan datos"])[0]}`,
          { title: "Faltan datos", variant: "warning", solid: false, noAutoHide: true }
        );
      }
      if (respuesta.status === 409) {
        return this.$bvToast.toast(datos.message || "El envío no se repitió", {
          title: "Sin cambios",
          variant: "info",
          solid: false,
        });
      }
      if (respuesta.status === 423) {
        return this.$bvToast.toast(
          datos.message || "Ya hay un envío en curso para esta plantilla.",
          { title: "Envío en curso", variant: "warning", solid: false }
        );
      }
      return this.$bvToast.toast(
        datos.message || "No se pudo completar el envío a la APP Copec.",
        { title: "Error", variant: "danger", solid: false, noAutoHide: true }
      );
    },
    hasDocumentTypeOptions(item) {
      return this.getDocumentTypeOptions(item).length > 0;
    },
    getDocumentTypeOptions(item) {
      let options = [];

      if (this.verifyIfChecklistFieldReport(item)) {
        options = [
          {
            value: this.getTypeChecklistFromChecklist(item),
            text: "Report de Terreno (.docx)",
          },
        ];
      } else if (this.verifyIfChecklistIdTechnicalReport(item)) {
        options = [
          {
            value: this.getTypeChecklistFromChecklist(item),
            text: "Informe de Visita (.docx)",
          },
        ];
      } else {
        options = [
          { value: "residencial", text: "Residencial (.docx)" },
          { value: "oneperpage", text: "Una imagen por pagina (.docx)" },
          { value: "imagestandar", text: "Imagenes estandar (.docx)" },
          { value: "comisionamiento", text: "Comisionamiento (.docx)" },
          { value: "reporte", text: "Reporte Prevención de Riesgos (.pdf)" },
        ];
      }


      return options;
    },
    openDownloadDocxModal(item) {
      this.currentChecklistToDownload = item;
      this.availableDocumentTypes = this.getDocumentTypeOptions(item);
      this.selectedDownloadDocumentType = null;
      this.recipientEmail = "";
      this.errorMessage = "";
      this.$bvModal.show("modal-download-docx");
    },
    async downloadSelectedDocxType() {
      if (!this.currentChecklistToDownload || !this.selectedDownloadDocumentType) {
        return;
      }

      if (this.selectedDownloadDocumentType === "reporte") {
        await this.getPdfPrevencion(this.currentChecklistToDownload);
        this.$bvModal.hide("modal-download-docx");
        this.currentChecklistToDownload = null;
        this.selectedDownloadDocumentType = null;
        return;
      }

      await this.getDocxChecklist(
        this.currentChecklistToDownload,
        this.selectedDownloadDocumentType
      );
      this.$bvModal.hide("modal-download-docx");
      this.currentChecklistToDownload = null;
      this.selectedDownloadDocumentType = null;
    },
    async sendDocxByEmail() {
      if (
        !this.currentChecklistToDownload ||
        !this.selectedDownloadDocumentType ||
        !this.isRecipientEmailValid
      ) {
        return;
      }

      if (this.selectedDownloadDocumentType === "reporte") {
        this.errorMessage = "";
        this.isLoading = true;
        const response = await this.getDocxFromPlaceChecklist({
          place_checklist_id: this.currentChecklistToDownload.id,
          type: this.getTypeChecklistFromChecklist(this.currentChecklistToDownload),
          output_format: "pdf",
          recipient_email: this.recipientEmail.trim(),
          send_email: true,
          responseType: "json",
        });

        if (response && (response.status === 200 || response.status === 201)) {
          this.$bvToast.toast(
            "El reporte de Prevención de Riesgos se está procesando y será enviado al correo indicado.",
            {
              title: "Excelente",
              variant: "primary",
              solid: false,
            }
          );
          this.$bvModal.hide("modal-download-docx");
          this.currentChecklistToDownload = null;
          this.selectedDownloadDocumentType = null;
          this.recipientEmail = "";
        } else {
          this.errorMessage =
            (response && response.data && response.data.error) ||
            "No fue posible enviar el reporte por correo.";
        }
        this.isLoading = false;
        return;
      }

      this.errorMessage = "";
      this.isLoading = true;
      const response = await this.getDocxFromPlaceChecklist({
        place_checklist_id: this.currentChecklistToDownload.id,
        type: this.selectedDownloadDocumentType,
        recipient_email: this.recipientEmail.trim(),
        send_email: true,
        responseType: "json",
      });

      if (response && (response.status === 200 || response.status === 201)) {
        this.$bvToast.toast(
          "El informe se está procesando y será enviado al correo indicado.",
          {
            title: "Excelente",
            variant: "primary",
            solid: false,
          }
        );
        this.$bvModal.hide("modal-download-docx");
        this.currentChecklistToDownload = null;
        this.selectedDownloadDocumentType = null;
        this.recipientEmail = "";
      } else {
        this.errorMessage =
          (response && response.data && response.data.error) ||
          "No fue posible enviar el informe por correo.";
      }
      this.isLoading = false;
    },
    async verifyIfChecklistHaveQuestionsRequiredAnswered(item) {
      let verification = true;
      if (this.verifyIfChecklistIdTechnicalReport(item)) {
        let questions = await this.getQuestions({
          checklist_id: item.checklist.id,
          place_id: this.$route.params.id,
        });
        //Saca el ultimo elemento del array y deja los primeros solamente
        let questionsToVerify = questions.slice(0, -1);
        questionsToVerify.forEach((question) => {
          question.child.forEach((child) => {
            if (
              !child.answers.length ||
              !child.answers.find((answer) => answer.rejected_at == null)
            ) {
              verification = false;
            }
          });
        });
        return verification;
      }
      return verification;
    },
    async getDocxChecklist(item, type) {
      this.$bvToast.toast(
        `Se esta validando la información para generar el documento, espere un poco`,
        {
          title: `Atención`,
          variant: "info",
          solid: false,
        }
      );
      let validationQuestions =
        await this.verifyIfChecklistHaveQuestionsRequiredAnswered(item);
      if (!validationQuestions) {
        return this.$bvToast.toast(
          `Para poder descargar el Informe de Visita debe responder todas las preguntas obligatorias`,
          {
            title: `Atención`,
            variant: "danger",
            solid: false,
          }
        );
      }
      this.loading = true;
      const response = await this.getDocxFromPlaceChecklist({
        place_checklist_id: item.id,
        type,
      });

      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const linkToDownloadDocx = document.createElement("a");
        linkToDownloadDocx.setAttribute("href", url);
        linkToDownloadDocx.setAttribute("target", "_blank");
        linkToDownloadDocx.setAttribute(
          "download",
          `${this.place.project.code}-${item.checklist.name}.docx`
        );
        linkToDownloadDocx.click();
        this.loading = false;
      }
      if (response.status == 201) {
        this.$bvToast.toast(
          `El archivo se esta generando en segundo plano, al finalizar sera enviado a su correo electrónico.`,
          {
            title: `Excelente`,
            variant: "primary",
            solid: false,
            noAutoHide: true, // evitar auto cierre
            autoHideDelay: 0,
          }
        );
        this.loading = false;
      }
    },
    async getPdfPrevencion(item) {
      if (!item.checklist || item.checklist.status_completed < 100) {
        return;
      }
      this.$bvToast.toast(
        `Generando PDF de Prevención de Riesgos, espere un momento`,
        {
          title: `Atención`,
          variant: `info`,
          solid: false,
        }
      );
      this.loading = true;
      const response = await this.getDocxFromPlaceChecklist({
        place_checklist_id: item.id,
        type: this.getTypeChecklistFromChecklist(item),
        output_format: "pdf",
      });
      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("target", "_blank");
        link.setAttribute(
          "download",
          `${this.place.project.code}-${item.checklist.name}.pdf`
        );
        link.click();
      } else {
        let msg = "Error al generar PDF";
        try {
          const text = await response.data.text();
          const json = JSON.parse(text);
          msg = json.error || msg;
        } catch (e) {
          msg = response.statusText || msg;
        }
        this.$bvToast.toast(msg, {
          title: `Error`,
          variant: "danger",
          solid: false,
        });
      }
      this.loading = false;
    },
    goToQuestionsChecklist(item) {
      this.$router.push({
        name: "place-checklist",
        params: {
          id: this.$route.params.id,
          checklistId: item.checklist.id,
        },
      }).catch(() => {});
    },
    deleteAnswersPlaceChecklist(item) {
      this.$bvModal
        .msgBoxConfirm("Esta acción no se puede revertir", {
          title:
            "¿Estas seguro de limpiar todas las respuestas de esta plantilla?.",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Limpiar",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-info-3",

          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.sendDeleteAnswersPlaceChecklist(item.id);
            if (resp.status == 200) {
              this.$bvToast.toast(
                `Respuestas de plantilla eliminadas correctamente`,
                {
                  title: `Excelente`,
                  variant: "primary",
                  solid: false,
                }
              );
            }
            this.getPlaceChecklists({
              place_id: this.$route.params.id,
              section: this.filters.section || undefined,
            });
          }
        })
        .catch((err) => {
          return err;
        });
    },
    deletePlaceChecklist(item) {
      this.$bvModal
        .msgBoxConfirm("Esta acción no se puede revertir", {
          title: "¿Estas seguro de eliminar esta plantilla?.",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Eliminar",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-info-3",

          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            const resp = await this.sendDeletePlaceChecklist(item.id);
            if (resp.status == 204) {
              this.$bvToast.toast(
                `Plantilla de Punto de instalación eliminada correctamente`,
                {
                  title: `Excelente`,
                  variant: "primary",
                  solid: false,
                }
              );
            }
            this.getPlaceChecklists({
              place_id: this.$route.params.id,
              section: this.filters.section || undefined,
            });
          }
        })
        .catch((err) => {
          return err;
        });
    },
    async goToRejected(item) {
      if (item.checklist.status.rejected_total > 0) {
        const resp = await this.getQuestionsRejected({
          place_checklist_id: item.id,
          page: 0,
          size: 1000,
        });
        this.imagesRejectedQuestion = resp.data;
        this.$bvModal.show("modal-questions-answers-rejected");
      }
    },
  },
  computed: {
    ...mapGetters({
      checklistDOCXProgress: "checklist/checklistDOCXProgress",
      placeChecklists: "place/placeChecklists",
      place: "place/place",
      currentUser: "auth/currentUser",
      sections: "project/sections",
      sectionsUser: "project/sectionsUser",
      userAuth: "auth/userAuth",
      copecStatuses: "integrations/copecStatuses",
      copecConfiguredChecklistId: "integrations/copecConfiguredChecklistId",
    }),
    wrappedSections() {
    if (this.userAuth?.rol == ROLES.superadmin) {
        return this.sections;
      }
      return this.sectionsUser;
    },
    camposTabla() {
      // La integración aplica a una plantilla entre cientos, así que la columna
      // sólo se pinta si esa plantilla está en el listado que se está viendo.
      // Como sigue a las filas, también sigue al filtro de sección.
      if (!this.computedPlaceChecklists.some((item) => this.aplicaCopec(item))) {
        return this.fields;
      }
      return this.fields.concat([
        {
          key: "copec",
          label: "Integración APP Copec",
          sortable: false,
          class: "text-center px-1",
        },
      ]);
    },
    computedPlaceChecklists() {
      return this.placeChecklists.filter((e) => e);
    },
    isRecipientEmailValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test((this.recipientEmail || "").trim());
    },
  },
};
</script>
<style scoped>
.btn.disabled {
  pointer-events: all;
}
.pointer {
  cursor: pointer;
}

.download-docx-select {
  min-height: 40px;
  border: 1px solid #dfe6e9;
  border-radius: 8px;
  background-color: #fff;
}
</style>
